"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamCollector = function (stream) {
    return new Response(stream)
        .arrayBuffer()
        .then(function (arrayBuffer) { return new Uint8Array(arrayBuffer); });
};
//# sourceMappingURL=index.js.map